import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { get_banners } from "../store/reducers/homeReducer";
import { useSelector, useDispatch } from "react-redux";
import ProductDetailsModal from "./ProductDetailsModal";

const Banner = ({ sellerId, sellerName }) => {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.home);
  const { supportInfo } = useSelector((state) => state.auth);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    dispatch(get_banners(sellerId));
  }, [dispatch, sellerId]);
  if (!sellerName) {
    console.warn('Banner: sellerName is undefined');
    return null; // or return <div>Loading...</div>;
  }

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const handleBannerClick = (banner) => {
    // If banner has product information, show product modal
    if (banner.product) {
      setSelectedProduct(banner.product);
      setIsModalOpen(true);
    }
    // If banner has productId but no populated product, try to navigate by slug
    else if (banner.productSlug) {
      window.location.href = `/${sellerName}/product/details/${banner.productSlug}`;
    }
    // If link is a product slug, navigate to product page
    else if (banner.link) {
      window.location.href = `/${sellerName}/product/details/${banner.link}`;
    }
  };

  const CustomDot = ({ onClick, ...rest }) => {
    const {
      onMove,
      index,
      active,
      carouselState: { currentSlide, deviceType }
    } = rest;
    return (
      <button
        className={`w-3 h-3 mx-1 rounded-full transition-all duration-300 ${
          active ? 'bg-indigo-600 scale-125' : 'bg-gray-300 hover:bg-indigo-400'
        }`}
        onClick={() => onClick()}
      />
    );
  };

  return (
    <>
      <div className="w-full mt-6">
        <div className="w-[90%] mx-auto">
          <div className="w-full">
            <div className="my-8">
              <Carousel
                autoPlay={true}
                infinite={true}
                arrows={true}
                showDots={true}
                responsive={responsive}
                customDot={<CustomDot />}
                renderButtonGroupOutside={true}
                customTransition="transform 300ms ease-in-out"
                containerClass="banner-carousel"
                dotListClass="custom-dot-list"
                itemClass="carousel-item-padding-40-px"
                className="banner-carousel-container"
              >
                {banners &&
                  banners?.length > 0 &&
                  banners?.map((b, i) => (
                    <div
                      className="block w-full flex justify-center items-center cursor-pointer group"
                      key={i}
                      onClick={() => handleBannerClick(b)}
                    >
                      <div className="relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl">
                      <img
                          className="w-auto max-h-[440px] object-contain rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                        src={b.banner}
                        alt="Banner"
                      />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      </div>
                    </div>
                  ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>

      {/* Product Details Modal */}
      <ProductDetailsModal
        product={selectedProduct}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedProduct(null);
        }}
        sellerName={sellerName}
        sellerId={sellerId}
        supportInfo={supportInfo}
      />
    </>
  );
};

export default Banner;
